import React from "react";

export default function DemoBanner() {
  return (
    <div
      data-testid="demo-banner"
      style={{
        display: "flex", alignItems: "center", gap: 10,
        background: "var(--sv-watch-bg)", borderBottom: "1px solid var(--sv-watch)",
        color: "var(--sv-watch)", padding: "7px 30px", fontSize: 12.5,
        fontFamily: "'Inter', sans-serif", fontWeight: 500, letterSpacing: 0.2,
      }}
    >
      <span style={{ width: 7, height: 7, borderRadius: 9999, background: "var(--sv-watch)" }} />
      Demo data — not connected to Simpro
    </div>
  );
}
